enum PlanProgressModels {
  PERIOD_TARGET = "PERIOD_TARGET",
}

export default PlanProgressModels;
